let stringUrl = {
  stockOverview: {
    stats: ["/stock-overview", "/stock-overview/document", "/stock-overview/virtual", "/stock-overview/sipb-unfill", "/stock-indent"],
    stockSales: ["/sales-vs-stock"],
    mainDealerStock: ["/main-dealer-stock"],
    dealerStock: ["/dealer-stock"],
  },

  stockAnalytics: {
    agingStockAnalysis: [
      "/aging-stock-analysis/maindealer",
      "/aging-stock-analysis/dealer",
      // '/aging-stock-analysis/end-to-end'
    ],
    stockDays: [
      "/stock-days/maindealer",
      "/stock-days/dealer",
      // '/stock-days/end-to-end'
    ],
    stockByProductionYears: ["/stock-by-production-years/maindealer", "/stock-by-production-years/dealer"],
    movementStock: ["/movement-stock/chart-summary/by-model", "/movement-stock/in-out"],
    // averageAgingStock : [
    //     '/average-aging-stock/maindealer',
    //     '/average-aging-stock/dealer'
    // ]
    stockDaysMarket: ["/stock-days/stock-days-market"],
    outerStock: ["/outer-stock"],
  },

  leadTime: {
    deliverShipping: ["/late-delivery-shipping/ahm-to-md", "/late-delivery-shipping/md-to-d"],
    deliveryShippingTransporter: ["/late-delivery-shipping/transporter", "/late-delivery-shipping/transporter"],
    leadtimeTransporter: ["/late-delivery-shipping/lead-time"],
  },

  salesAnalysis: {
    salesAnalysis: ["/sales-analysis", "/sales-analysis"],
  },

  territoryManagement: {
    territoryManagement: ["/territory-management", "/territory-management/service", "/territory-management/sales-by-document", "/territory-management/market-contribution?by=SCAN", "/territory-management/market-contribution?by=DOCUMENT", "/territory-management/market-contribution/by-dealer"],
  },

  mappingSummary: {
    mappingSummary: ["/mapping-summary/h1", "/mapping-summary/h2", "/mapping-summary/total"],
  },

  serviceAnalysis: {
    serviceAnalysis: ["/service-analysis", "/service-analysis"],
  },
};

let param = {
  stockOverview: {
    stats: [
      {
        var: "stockOverview",
        parent: "stockOverviewData",
        filter: "stockOverviewFilter",
        filterVar: "stockOverview",
      },
      {
        var: "stockOverviewDocument",
        parent: "stockOverviewData",
        filter: "stockOverviewFilter",
        filterVar: "stockOverview",
      },
      {
        var: "stockOverviewVirtual",
        parent: "stockOverviewData",
        filter: "stockOverviewFilter",
        filterVar: "stockOverview",
      },
      {
        var: "stockOverviewSipbUnfill",
        parent: "stockOverviewData",
        filter: "stockOverviewFilter",
        filterVar: "stockOverview",
      },
      {
        var: "stockOverviewStockInden",
        parent: "stockOverviewData",
        filter: "stockOverviewFilter",
        filterVar: "stockOverview",
      },
    ],
    stockSales: [
      {
        var: "stockSales",
        parent: "stockOverviewData",
        filter: "stockOverviewFilter",
        filterVar: "stockSales",
      },
    ],
    mainDealerStock: [
      {
        var: "mainDealerStock",
        parent: "stockOverviewData",
        filter: "stockOverviewFilter",
      },
    ],
    dealerStock: [
      {
        var: "dealerStock",
        parent: "stockOverviewData",
        filter: "stockOverviewFilter",
      },
    ],
  },

  stockAnalytics: {
    agingStockAnalysis: [
      {
        var: "agingStockMD",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "agingStockOptions",
      },
      {
        var: "agingStockD",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "agingStockOptionsDealer",
      },
      {
        var: "agingStockEnd",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "agingStockOptions",
      },
    ],
    stockDays: [
      {
        var: "stockDaysMD",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "stockDaysOptions",
      },
      {
        var: "stockDaysD",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "stockDaysOptionsDealer",
      },
      // {
      //     var: 'stockDaysEnd',
      //     parent: 'stockAnalyticsData',
      //     filter: 'stockAnalyticsFilter',
      //     filterVar: 'stockDaysOptions'
      // }
    ],
    stockDaysMarket: [
      {
        var: "stockDaysMarket",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "stockDaysMarket",
      },
    ],
    stockByProductionYears: [
      {
        var: "stockByProductionYearsMD",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "stockByProductionYearsOptions",
      },
      {
        var: "stockByProductionYearsD",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "stockByProductionYearsOptionsDealer",
      },
    ],
    movementStock: [
      {
        var: "movementStockSubSeries",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "movementStockOptions",
      },
      {
        var: "movementStockTable",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "movementStockOptions",
      },
    ],
    outerStock: [
      {
        var: "outerStock",
        parent: "stockAnalyticsData",
        filter: "stockAnalyticsFilter",
        filterVar: "outerStockOptions",
      },
    ],
    // averageAgingStock : [
    //     {
    //         var: 'averageAgingMD',
    //         parent: 'stockAnalyticsData',
    //         filter: 'stockAnalyticsFilter',
    //         filterVar: 'averageAgingStockOptions'
    //     },
    //     {
    //         var: 'averageAgingD',
    //         parent: 'stockAnalyticsData',
    //         filter: 'stockAnalyticsFilter',
    //         filterVar: 'averageAgingStockOptions'
    //     }
    // ]
  },

  leadTime: {
    deliverShipping: [
      {
        var: "delivery_ahm_to_md",
        parent: "lateDeliveryAndShippingData",
        filter: "lateDeliveryAndShippingFilter",
        filterVar: "lateDeliveryShipping",
      },
      {
        var: "delivery_md_to_d",
        parent: "lateDeliveryAndShippingData",
        filter: "lateDeliveryAndShippingFilter",
        filterVar: "lateDeliveryShipping",
      },
    ],
    deliveryShippingTransporter: [
      {
        var: "transporter_ahm_to_md",
        parent: "lateDeliveryAndShippingData",
        filter: "lateDeliveryAndShippingFilter",
        filterVar: "lateDeliveryShippingTransporterAHM",
      },
      {
        var: "transporter_md_to_d",
        parent: "lateDeliveryAndShippingData",
        filter: "lateDeliveryAndShippingFilter",
        filterVar: "lateDeliveryShippingTransporterMD",
      },
    ],
    leadtimeTransporter: [
      {
        var: "leadtime_transporter",
        parent: "lateDeliveryAndShippingData",
        filter: "lateDeliveryAndShippingFilter",
        filterVar: "leadtimeTransporter",
      },
    ],
  },

  salesAnalysis: {
    salesAnalysis: [
      {
        var: "salesAnalysis",
        parent: "salesAnalysisData",
        filter: "salesAnalysisFilter",
        filterVar: "salesAnalysis",
      },
      {
        var: "salesAnalysisWeekly",
        parent: "salesAnalysisData",
        filter: "salesAnalysisFilter",
        filterVar: "salesAnalysis",
      },
    ],
  },

  territoryManagement: {
    territoryManagement: [
      {
        var: "territory",
        parent: "territoryManagementData",
        filter: "territoryManagementFilter",
        filterVar: "territoryOptions",
      },
      {
        var: "territoryService",
        parent: "territoryManagementData",
        filter: "territoryManagementFilter",
        filterVar: "territoryOptions",
      },
      {
        var: "territorySalesByDocument",
        parent: "territoryManagementData",
        filter: "territoryManagementFilter",
        filterVar: "territoryOptions",
      },
      {
        var: "territoryMarket",
        parent: "territoryManagementData",
        filter: "territoryManagementFilter",
        filterVar: "territoryOptions",
      },
      {
        var: "territoryMarketDocument",
        parent: "territoryManagementData",
        filter: "territoryManagementFilter",
        filterVar: "territoryOptions",
      },
      {
        var: "territoryMarketDealer",
        parent: "territoryManagementData",
        filter: "territoryManagementFilter",
        filterVar: "territoryOptions",
      },
    ],
  },

  mappingSummary: {
    mappingSummary: [
      {
        var: "mappingH1",
        parent: "mappingSummaryData",
        filter: "mappingSummaryFilter",
        filterVar: "mappingSummary",
      },
      {
        var: "mappingH2",
        parent: "mappingSummaryData",
        filter: "mappingSummaryFilter",
        filterVar: "mappingSummary",
      },
      {
        var: "mappingTotal",
        parent: "mappingSummaryData",
        filter: "mappingSummaryFilter",
        filterVar: "mappingSummary",
      },
    ],
  },

  serviceAnalysis: {
    serviceAnalysis: [
      {
        var: "serviceAnalysis",
        parent: "serviceAnalysisData",
        filter: "serviceAnalysisFilter",
        filterVar: "serviceAnalysis",
      },
      {
        var: "serviceAnalysisWeekly",
        parent: "serviceAnalysisData",
        filter: "serviceAnalysisFilter",
        filterVar: "serviceAnalysis",
      },
    ],
  },
};

module.exports = { stringUrl, param };
